// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c5011fef","453":"cc37e9da","455":"26c24e95","977":"c7b05c8a"}[chunkId] + ".chunk.js";
};